var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.45 40.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#134fc8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.83,0H5.62A5.62,5.62,0,0,0,0,5.62V34.94a5.62,5.62,0,0,0,5.62,5.62H50.83a5.62,5.62,0,0,0,5.62-5.62V5.62A5.62,5.62,0,0,0,50.83,0Zm3.5,34.94a3.5,3.5,0,0,1-3.5,3.5H5.62a3.5,3.5,0,0,1-3.49-3.5V5.62A3.49,3.49,0,0,1,5.62,2.13H50.83a3.5,3.5,0,0,1,3.5,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.4,7.42A1.88,1.88,0,0,0,7.53,9.3v22a1.88,1.88,0,1,0,3.75,0V9.3A1.88,1.88,0,0,0,9.4,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.93,7.42A1.88,1.88,0,0,0,15.06,9.3V23.94a1.88,1.88,0,0,0,3.75,0V9.3A1.88,1.88,0,0,0,16.93,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.46,7.42A1.88,1.88,0,0,0,22.59,9.3V23.94a1.88,1.88,0,0,0,3.75,0V9.3A1.88,1.88,0,0,0,24.46,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,7.42A1.88,1.88,0,0,0,30.11,9.3V23.94a1.88,1.88,0,0,0,3.76,0V9.3A1.88,1.88,0,0,0,32,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.52,7.42A1.88,1.88,0,0,0,37.64,9.3V23.94a1.88,1.88,0,0,0,3.75,0V9.3A1.88,1.88,0,0,0,39.52,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,7.42A1.88,1.88,0,0,0,45.17,9.3v22a1.88,1.88,0,1,0,3.75,0V9.3A1.88,1.88,0,0,0,47.05,7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.93,29.39a1.88,1.88,0,1,0,1.88,1.87A1.87,1.87,0,0,0,16.93,29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.46,29.39a1.88,1.88,0,1,0,1.88,1.87A1.87,1.87,0,0,0,24.46,29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,29.39a1.88,1.88,0,1,0,1.88,1.87A1.88,1.88,0,0,0,32,29.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.52,29.39a1.88,1.88,0,1,0,1.87,1.87A1.88,1.88,0,0,0,39.52,29.39Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSent);
export default __webpack_public_path__ + "static/media/ticket-sent.c9cbbda7ab15d0fc1883f975eeb57d55.svg";
export { ForwardRef as ReactComponent };